import { render } from "./SendPrivateMessage.vue?vue&type=template&id=dc0a33bc&scoped=true"
import script from "./SendPrivateMessage.vue?vue&type=script&lang=js"
export * from "./SendPrivateMessage.vue?vue&type=script&lang=js"

import "./SendPrivateMessage.vue?vue&type=style&index=0&id=dc0a33bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0a33bc"]])

export default __exports__